import { Icons, Progress } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { useNotification } from 'hooks/useNotification'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Task, TaskType } from 'modules/domain/task/types'
import { User } from 'modules/domain/user/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { EndCallModal } from './EndCallModal'

type Props = {
  refetch: refetchFunc | (() => void)
  successText: string
  task: Task
  forDashboard?: boolean
  user?: User
  userRefetch?: refetchFunc
}

export const CompleteTaskBtn: FC<Props> = ({ refetch, task, successText, forDashboard, user, userRefetch }) => {
  const { t } = useTranslation('task')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const notify = useNotification()

  const [progress, completeTask] = useAProgress(() => apiClient.post(endpoints.completeTask(task.id)), {
    eventName: 'completeTask',
    analyticsPayload: {
      id: task.id,
    },
    onSuccess: () => {
      notify(Progress.SUCCESS, { title: successText })
      refetch(true)
    },
  })

  const actionBtn = () => {
    if (task.task_type === TaskType.CALL || task.task_type === TaskType.NEW_USER) {
      setIsModalOpen(true)
      return
    }
    completeTask()
  }

  return (
    <>
      {forDashboard ? (
        <AButton
          Icon={Icons.IconDone}
          progress={progress}
          onClick={actionBtn}
          color="secondary"
          id="completeTask"
          size="small"
        >
          {t('task:makeComplete')}
        </AButton>
      ) : (
        <AButton
          id="completeTask"
          Icon={Icons.IconApprove}
          progress={progress}
          onClick={actionBtn}
          color="secondary"
          background="none"
        />
      )}
      {isModalOpen && (
        <EndCallModal
          user={user}
          refetch={refetch}
          onClose={() => setIsModalOpen(false)}
          task={task}
          userRefetch={userRefetch}
        />
      )}
    </>
  )
}
